// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4871":"5e0c6b08a141c04c","6291":"8b77e2da2a18e6f6"}[chunkId] + ".js";
};